import "babel-polyfill";
import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';

import store from './store';
import Axios from 'axios';
import instance from './api-services/axios.instance'
import { AuthModel } from './api-services/auth.service'

import { config } from './config';

import Numbers from './components/numbers.vue';
import Tries from './components/gettries.vue';
import GetLucky from './components/getlucky.vue';
import Subscribe from './components/subscribe.vue';
import Footer from './components/footer.vue';
import Header from './components/header.vue';

import './../node_modules/jquery/dist/jquery.min.js';
import './../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './../node_modules/bootstrap/dist/js/bootstrap.min.js';

import './assets/css/site.css';

//Axios.defaults.baseURL = config.$api_url;

Vue.prototype.appConfig = config;
//Vue.prototype.$http = Axios;

Vue.use(VueRouter);

const routes = [
  { path: '/', name: 'subscribe', component: Subscribe },
  { path: '/a/:id', name:'numbers_history', component: Numbers},
  { path: '/tries/', name:'tries', component: Tries },
  { path: '/gl/:id', name:'getlucky', component: GetLucky }
];

const router = new VueRouter({
  mode: 'history',
  routes: routes,
  base: process.env.ROUTER_BASE
});

const token = localStorage.getItem('token')

new Vue({
  el: '#app',
  store,
  router: router,
  beforeCreate: function () {

    //console.log('Component before created!');

    if (token) {

      //this.$router.push('/code')

      //Axios.defaults.headers.Authorization = 'Bearer ' + token

      if (this.$route.name == 'numbers_history') {
        //store.dispatch('getNumbers', { type: 'daily', id: this.$route.params.id }).then(resp => { /* do someting */ }).catch(err => { console.log(err) });
        //store.dispatch('getNumbers', { type: 'weekly', id: this.$route.params.id }).then(resp => { /* do someting */ }).catch(err => { console.log(err) });
        //store.dispatch('getNumbers', { type: 'monthly', id: this.$route.params.id }).then(resp => { /* do someting */ }).catch(err => { console.log(err) });
        //store.dispatch('getNumbers', { type: 'yearly', id: this.$route.params.id }).then(resp => { /* do someting */ }).catch(err => { console.log(err) });
      }
    }
    else {

      const access = {
        grant_type: config.api_grant_type,
        username: config.api_username,
        password: config.api_password,
        client_id: config.api_client_id,
        client_secret: config.api_client_secret,
        scope: '*'
      };

      //AuthModel.login(access).then(resp => { console.log(resp) }).catch(err => console.log(err));
    }
  },
  render: h => h(App)
})

new Vue({
  el: '#footer',
  store,
  router: router,
  render: h => h(Footer)
})

new Vue({
  el: '#header',
  store,
  router: router,
  render: h => h(Header)
})


// WEBPACK FOOTER //
// ./src/main.js